module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-BoldItalic.084f4fc8.ttf";